import styled from 'styled-components';

export const PageContainer = styled.main`
  max-width: 1200px;
  margin: auto;
  padding: 0 16px;

  @media(max-width: 768px) {
    padding: 0 12px;
  }

  @media(max-width: 480px) {
    padding: 0 8px;
  }
`;